// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".action-button[data-v-4a39ef40]{max-width:var(--space-giga)}", "",{"version":3,"sources":["/home/ubuntu/chatwoot/chatwoot/app/javascript/dashboard/components/widgets/modal/DeleteModal.vue"],"names":[],"mappings":"AACA,gCACE,2BAAA","file":"DeleteModal.vue","sourcesContent":["\n.action-button {\n  max-width: var(--space-giga);\n}\n"]}]);
// Exports
module.exports = exports;
